import * as React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import { useFetchCache } from "components/lookup-tables/hooks/useLookupTablesAPI";
import CacheShow from "./cache-show";
function CacheView() {
  const { t } = useTranslation("lookup_tables");
  const { cacheIdOrName } = useParams();
  const { cache, loadingCache } = useFetchCache(cacheIdOrName);
  if (loadingCache) return /* @__PURE__ */ React.createElement(Spinner, { text: t("cache_view.loading") });
  return /* @__PURE__ */ React.createElement(CacheShow, { cache });
}
export default CacheView;
